/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h3[_ngcontent-%COMP%]   small[_ngcontent-%COMP%] {\n  font-size: 0.4em;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/app.component.css.shim.ngstyle.js.pre-build-optimizer.js